var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrack = function SvgTrack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1001_2314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.547 10.543L20.417.108a.871.871 0 0 0-.834 0L.453 10.543a.87.87 0 0 0-.453.764v6.956a.87.87 0 0 0 1.286.764l3.931-2.145v21.381H.87a.87.87 0 0 0 0 1.74h38.26a.87.87 0 0 0 0-1.74h-4.348V16.882l3.932 2.145A.871.871 0 0 0 40 18.263v-6.956a.87.87 0 0 0-.453-.764zm-6.504 27.72H6.956v-22.33L20 8.82l13.043 7.114v22.33zm5.218-21.465L20.416 7.065a.871.871 0 0 0-.833 0L1.74 16.798v-4.976L20 1.862l18.262 9.96v4.976z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.13 16.522v2.609h-4.347a.87.87 0 0 0-.87.87v5.217c0 .48.39.87.87.87h4.347v3.478h-4.347a.87.87 0 0 0 0 1.739h4.347v2.608a.87.87 0 0 0 1.74 0v-2.608h4.347c.48 0 .87-.39.87-.87v-5.217a.87.87 0 0 0-.87-.87H20.87V20.87h4.347a.87.87 0 0 0 0-1.74H20.87v-2.608a.87.87 0 0 0-1.74 0zm5.218 9.565v3.479H20.87v-3.479h3.478zm-5.218-1.739h-3.478V20.87h3.478v3.478z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1001_2314"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgTrack;